import Logo from '../../ui/Logo/Logo.jsx';
import styles from './LogoStrip.module.css';

// ASSET SLOT: each entry can take a `logo` path once you have real marks.
// Expected files (SVG, single color or full-color, ~24x24):
//   src/assets/logos/nexora.svg
//   src/assets/logos/cloudify.svg
//   src/assets/logos/payvista.svg
//   src/assets/logos/datavault.svg
//   src/assets/logos/orbitis.svg
//   src/assets/logos/summatech.svg
// Until those exist, each brand falls back to a generated placeholder mark.
const brands = [
  { name: 'Nexora' },
  { name: 'Cloudify' },
  { name: 'Payvista' },
  { name: 'Datavault' },
  { name: 'Orbitis' },
  { name: 'Summatech' },
];

export default function LogoStrip() {
  return (
    <section className={styles.strip}>
      <div className="container">
        <div className={styles.panel}>
          <p className={styles.label}>Trusted by innovative companies</p>
          <div className={styles.row}>
            {brands.map((b) => (
              <span key={b.name} className={styles.brand}>
                {b.logo ? (
                  // eslint-disable-next-line jsx-a11y/alt-text
                  <img src={b.logo} className={styles.brandLogo} alt={`${b.name} logo`} />
                ) : (
                  <span className={styles.brandMark} aria-hidden="true">
                    <Logo withWordmark={false} size={18} />
                  </span>
                )}
                {b.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
